import Http from '@/services/http';
import { grammaticalJoin } from '@/services/arrayUtils';
import {
  CommutatorTemperatureDifferentialStatus,
  CommutatorReadingRequest,
  CommutatorReadingResponse,
  CommutatorDetails,
  CommutatorLastReadingRequest,
  CommutatorsChart,
  CommutatorParameter,
  ChartQuery,
} from 'sigma-mappings';

const urls = {
  status: assetModuleId => `/engenharia/${assetModuleId}/diferencial-temperatura-comutador/status`,
  commutatorReading: assetModuleId => `/engenharia/${assetModuleId}/diferencial-temperatura-comutador/comutador`,
  commutatorReadingPatch: assetModuleId => `/engenharia/${assetModuleId}/diferencial-temperatura-comutador/alterar-valor-maximo`,
  commutatorDetail: (assetModuleId, commutatorId) => `/engenharia/${assetModuleId}/diferencial-temperatura-comutador/comutador/${commutatorId}`,
  getCommutatorChart: assetModuleId => `/engenharia/${assetModuleId}/diferencial-temperatura-comutador/grafico`,
  getCommutatorParameters: assetModuleId => `/engenharia/${assetModuleId}/diferencial-temperatura-comutador/parametros`,
};

/* istanbul ignore next */
const error = {
  errorHandling: {
    responseMessageParams: {
      $MA078: (data) => {
        const parameters = Object.entries(data.parameters);
        const commutator = parameters[0][1];
        const variablesArray = parameters
          .slice(1, parameters.length)
          .map(item => item[1]);
        const variables = grammaticalJoin(variablesArray);
        return {
          variables,
          commutator,
        };
      },
      $MA085: (data) => {
        const parameters = Object.entries(data.parameters);
        const variable = parameters[0][1];
        return {
          variable,
        };
      },
    },
  },
};

export default {
  getStatus(assetModuleId) {
    const http = new Http(error);
    return http.get(urls.status(assetModuleId)).then(
      ({ data }) => new CommutatorTemperatureDifferentialStatus(data),
    );
  },
  getCommutatorReadings(assetModuleId, visualization) {
    const http = new Http(error);
    const params = new CommutatorReadingRequest({ visualization });
    return http.get(urls.commutatorReading(assetModuleId), { params }).then(
      ({ data }) => data.map(item => new CommutatorReadingResponse(item)),
    );
  },
  getCommutatorDetails(assetModuleId, commutatorId) {
    const http = new Http(error);
    return http.get(urls.commutatorDetail(assetModuleId, commutatorId)).then(
      ({ data }) => new CommutatorDetails(data),
    );
  },
  patchCommutatorDetails(assetModuleId, payload) {
    const http = new Http(error);
    const params = new CommutatorLastReadingRequest(payload);
    return http.patch(urls.commutatorReadingPatch(assetModuleId), params).then(
      ({ data }) => data,
    );
  },
  getChart(moduleAssetId, chartFilters) {
    const http = new Http(error);
    const params = new ChartQuery(chartFilters);
    return http.get(urls.getCommutatorChart(moduleAssetId), { params })
      .then(({ data }) => data.map(item => new CommutatorsChart(item)));
  },
  getParameters(moduleAssetId) {
    const http = new Http(error);
    return http.get(urls.getCommutatorParameters(moduleAssetId))
      .then(({ data }) => data.map(item => new CommutatorParameter(item)));
  },
};
